export default function heroSection({main, on, elm, state}) {
    const data = state.get();

    main(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        if ('requestIdleCallback' in window) {
            requestIdleCallback(loadAndSwapBg, { timeout: 1200 });
        } else {
            window.addEventListener('load', loadAndSwapBg, { once: true });
        }
    });

    const loadAndSwapBg = function() {
        const img = new Image();

        img.onload = () => {
            elm.style.setProperty('--anim-bg', `url("${data.animatedBg}")`);
            requestAnimationFrame(() =>
                requestAnimationFrame(() => elm.classList.add('_anim-shown'))
            );
        };

        img.onerror = () => {
            console.warn('Animated AVIF failed to load');
        };

        img.src = data.animatedBg;
    };
};

export const model = ({elm}) => {
    return {
        animatedBg: elm.dataset.animatedBg
    };
};